
import { Injectable } from '@angular/core';
import { deleteSession } from '../common/sessionHandler';

@Injectable()
export class LoginService {
  userLoggedIn: Boolean = false;

  constructor() { }

  logout() {
    this.userLoggedIn = false;
    deleteSession();

  }
}
